import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";

export const CartPage = ({ updateCart, deleteCart, isLoading, cart }) => {
  const navigate = useNavigate();
  const [totals, setTotals] = useState({ totalQuantity: 0, totalPrice: 0 });

    useEffect(() => {
        if(cart && cart.length > 0) {
            const result = cart.reduce(
            (acc, item) => {
                const quantity = parseInt(item.quantity) || 0;
                const currentPrice = parseFloat(item.Product?.currentPrice) || 0;
        
                acc.totalQuantity += quantity;
                acc.totalPrice += quantity * currentPrice;
        
                return acc;
            },
            { totalQuantity: 0, totalPrice: 0 }
            );
            setTotals(result);
        } else {
            setTotals({ totalQuantity: 0, totalPrice: 0 });
        }
      }, [cart]);

  return (
    <>
        <main className="container mb-4" style={{width: "1200px"}}>
            <div className="stepper" style={{ width: "1000px", margin: "40px auto"}}>
                <div className="step" id="step1">
                    <div className="number">1</div>
                    <span>Cart</span>
                </div>
                <div className="line"></div>
                <div className="step" id="step2">
                    <div className="number">2</div>
                    <span>Checkout</span>
                </div>
                <div className="line"></div>
                <div className="step" id="step3">
                    <div className="number">3</div>
                    <span>Payment</span>
                </div>
            </div>
            <div id="cart-page" className="page active">
                <div className="row">
                    <div className="col-lg-8">
                        <table className="table" style={{ border: "1px solid #8080802b", borderCollapse: "collapse"}}>
                            <thead>
                                <tr style={{border: "1px solid #8080802b"}}>
                                    <th style={{ border: "none", padding: "13px"}}>Products</th>
                                    <th style={{border: "none"}}> </th>
                                    <th style={{border: "none"}}> </th>
                                    <th style={{border: "none"}}> </th>
                                </tr>
                            </thead>
                            <tbody>
                                {cart.map(x => (
                                    <tr className="text-center align-middle" style={{border: "none", padding: "15px 10px 15px 10px"}}>
                                        <td className="d-flex align-items-center" style={{border: "none", padding: "15px 10px"}}>
                                            <img src={`${process.env.REACT_APP_ASSET_URL}/products/${x?.Product?.image}`} style={{width: "65px"}} alt="Product" className="me-3" />
                                            {x?.Product?.name}
                                        </td>
                                        <td style={{border: "none"}}>
                                            <div className="quantity-container">
                                                <button
                                                    className="quantity-button" id="decrement"
                                                    onClick={() => {
                                                        if(x?.quantity > 1) {
                                                            updateCart({ id: x?.id, quantity: parseInt(x?.quantity) - 1})
                                                        }
                                                    }}
                                                >-</button>
                                                <input type="number" id="quantity" className="quantity-input" value={x?.quantity} min="0" />
                                                <button
                                                    className="quantity-button"
                                                    id="increment"
                                                    onClick={() => {
                                                        if(x?.quantity < 10) {
                                                            updateCart({ id: x?.id, quantity: parseInt(x?.quantity) + 1})
                                                        }
                                                    }}
                                                >+</button>
                                            </div>
                                        </td>
                                        <td style={{border: "none"}}>₹ {x?.Product?.currentPrice}</td>
                                        <td style={{border: "none"}}>
                                            <button className="btn" onClick={() => deleteCart(x?.id)}>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                    <div className="col-lg-4">
                        <div className="cart-summary" style={{border: "1px solid #8080802b"}}>
                            <h5>Order Summary</h5>
                            <hr />
                            <div className="d-flex justify-content-between cm">
                                <span style={{color: "gray"}}>Products</span>
                                <span>{totals?.totalQuantity}</span>
                            </div>
                            <div className="d-flex justify-content-between cm">
                                <span>Subtotal</span>
                                <span>₹{totals?.totalPrice}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between cm">
                                <span>Already A Member?</span>
                                <span style={{color: "blue"}}>Login</span>
                            </div>
                            <button onClick={() => navigate("/checkout")} className="btn btn-success next-btn w-100" style={{backgroundColor: "#66A92F",
                            fontSize: "10px",
                            padding: "10px",
                            fontWeight: 500, 
                            marginBottom: "10px", border: "none"}}>CHECKOUT</button>

                            <button className="btn btn-outline-success w-100" style={{backgroundColor: "#66A92F",
                            fontSize: "10px",
                            padding: "10px",
                            fontWeight: 500, color: "white"}}>CONTINUE SHOPPING</button>

                        </div>
                    </div>
                </div>
            </div>
            <div id="checkout-page" className="page">
                <div className="container">
                    <h2 className="mb-4">Checkout</h2>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="alert alert-success" role="alert" style={{backgroundColor: "#D4EDDA"}}>
                                <i className="fa-solid fa-cart-shopping"
                                    style={{color: "red"}}></i><strong>Congratulations!</strong> Let's Complete Your Order
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="ch-header">
                                        <h5 className="card-title mb-4">Personal Info</h5>
                                    </div>
                                    <form>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label for="firstName" className="form-label">First Name</label>
                                                <input type="text" className="form-control" id="firstName"
                                                    placeholder="Enter your first name" />
                                            </div>
                                            <div className="col-md-6">
                                                <label for="lastName" className="form-label">Last Name</label>
                                                <input type="text" className="form-control" id="lastName"
                                                    placeholder="Enter your last name" />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label for="email" className="form-label">E-Mail</label>
                                                <input type="email" className="form-control" id="email"
                                                    placeholder="Enter your email" />
                                            </div>
                                            <div className="col-md-6">
                                                <label for="phone" className="form-label">Phone</label>
                                                <input type="text" className="form-control" id="phone"
                                                    placeholder="Enter your phone number" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="ch-header">
                                        <h5 className="card-title mb-4">Order option</h5>
                                    </div>
                                    <form>
                                        <div className="form-check mb-3">
                                            <input className="form-check-input" type="radio" name="orderOption"
                                                id="createAccount" value="create" />
                                            <label className="form-check-label" for="createAccount">
                                                Create an Account
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="orderOption"
                                                id="checkoutGuest" value="guest" />
                                            <label className="form-check-label" for="checkoutGuest">
                                                Checkout as Guest
                                            </label>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h5 className="card-title mb-4">Shipping Information</h5>
                                    <form>
                                        <div className="mb-3">
                                            <label for="country" className="form-label">Country:</label>
                                            <select id="country" className="form-select">
                                                <option selected>United States</option>
                                                <option value="1">Canada</option>
                                                <option value="2">United Kingdom</option>
                                                <option value="3">Australia</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label for="fullName" className="form-label">Full Name</label>
                                            <input type="text" className="form-control" id="fullName"
                                                placeholder="Enter your full name" />
                                        </div>
                                        <div className="mb-3">
                                            <label for="address1" className="form-label">Address Line 1</label>
                                            <input type="text" className="form-control" id="address1"
                                                placeholder="Enter your address" />
                                        </div>
                                        <div className="mb-3">
                                            <label for="address2" className="form-label">Address Line 2 (optional)</label>
                                            <input type="text" className="form-control" id="address2"
                                                placeholder="Enter your address" />
                                        </div>
                                        <div className="mb-3">
                                            <label for="city" className="form-label">City</label>
                                            <input type="text" className="form-control" id="city" placeholder="Enter your city" />
                                        </div>
                                        <div className="mb-3">
                                            <label for="state" className="form-label">State:</label>
                                            <select id="state" className="form-select">
                                                <option selected>Select State</option>
                                                <option value="CA">California</option>
                                                <option value="TX">Texas</option>
                                                <option value="NY">New York</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label for="zipCode" className="form-label">ZIP Code:</label>
                                            <input type="text" className="form-control" id="zipCode"
                                                placeholder="Enter your ZIP Code" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Your Order</h5>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <img src="./images/cart-image.png" style={{width: "50px"}} alt="Product"
                                            className="img-fluid" />
                                        <div className="ms-2">
                                            <p className="mb-0" style={{fontSize: "0.9rem"}}>Bio-Active Complete Multi...</p>
                                            <div className="input-group" style={{width: "90px", fontSize: "0.8rem"}}>
                                                <button className="btn btn-outline-secondary btn-sm px-2 py-1">-</button>
                                                <input type="text" className="form-control text-center" value="1" readonly
                                                    style={{height: "30px"}} />
                                                <button className="btn btn-outline-secondary btn-sm px-2 py-1">+</button>
                                            </div>
                                        </div>

                                        <p className="mb-0 ms-2" style={{fontSize: "0.9rem"}}>$14.95</p>
                                    </div>
                                    <hr />
                                    <p className="d-flex justify-content-between mb-2">
                                        <span>Retail Price</span>
                                        <span>$14.95</span>
                                    </p>
                                    <hr />
                                    <p className="d-flex justify-content-between">
                                        <strong>Total Payment</strong>
                                        <strong>$14.95</strong>
                                    </p>
                                    <button className="btn btn-success w-100"
                                        style={{backgroundColor: "#65A92E"}}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                <a href="#payment-page" className="btn btn-success next-btn"
                    style={{backgroundColor: "#66A92F", padding: "23px", fontSize: "20px"}}>Continue</a>

            </div>

            <div id="payment-page" className="page">
                <h3>Payment</h3>
                <a href="#checkout-page" className="btn btn-secondary prev-btn">Back to Checkout</a>
            </div>
        </main>
        <div className="full-row bg-dark py-30">
            <div className="container Newsletter">
                <div className="row mx-auto w-100">
                    <div className="col-lg-5 col-md-6 mx-auto">
                        <div className="d-flex align-items-center h-100">
                            <h4 className="text-white mb-0 text-uppercase">Sign up to newsletter </h4>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-12">
                        <form className="subscribe-form subscribeform  position-relative md-mt-20" method="POST">
                            <input className="form-control rounded-pill mb-0" type="text"
                                placeholder="Enter your email" aria-label="Address" name="email" />
                            <button type="submit"
                                className="btn btn-secondary rounded-right-pill text-white newsletter-submit">Send</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>
  );
};
